/**
 * Valentine's Week — 14–21 February every year.
 * Sale, bonus credits, and site theme share this window.
 */
export function getValentineYear(now = new Date()): number {
  return now.getFullYear();
}

export function isValentinePeriod(now = new Date()): boolean {
  const year = now.getFullYear();
  const start = new Date(year, 1, 14, 0, 0, 0);
  const end = new Date(year, 1, 21, 23, 59, 59);
  return now >= start && now <= end;
}

export const valentineColors = {
  pink: "330 80% 60%",
  rose: "350 80% 55%",
  red: "0 75% 50%",
  blush: "350 100% 88%",
};

export const valentineRecipeThemes = [
  { value: "date-night", label: "Date Night Dinner", emoji: "🕯️" },
  { value: "chocolate-romance", label: "Chocolate & Dessert", emoji: "🍫" },
  { value: "dinner-for-two", label: "Dinner for Two", emoji: "🍽️" },
  { value: "aphrodisiac", label: "Aphrodisiac Plates", emoji: "🍓" },
  { value: "heart-baking", label: "Heart Baking", emoji: "❤️" },
  { value: "galentine-brunch", label: "Galentine Brunch", emoji: "🥂" },
];
